/**
 * Build an error-banner message from a failed quote-API call. For an axios
 * 4xx whose body carries a string `detail` (FastAPI convention — note it can
 * be an array for 422 validation errors, so we only surface it when it's a
 * string), show that actionable detail; otherwise fall back to the supplied
 * generic message.
 */
export function createErrorMessage(err: unknown, fallback: string): string {
  const resp = (err as { response?: { status?: number; data?: { detail?: unknown } } })?.response;
  const status = resp?.status ?? 0;
  const detail = resp?.data?.detail;
  if (status >= 400 && status < 500 && typeof detail === 'string' && detail.trim()) {
    return detail;
  }
  return fallback;
}
